import { Serializable } from '../../../core/models/serializable';

export class CustomerAccountDetailsModel
  implements Serializable<CustomerAccountDetailsModel>
{
  fromObject(obj: any): CustomerAccountDetailsModel {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    let result = {
      VatStatusId: this.vatStatusId,
      VatStatus: this.vatStatus,
      CreditLimit: this.creditLimit,
      Balance: this.balance,
    };
    return result;
  }

  public vatStatusId: number;
  public vatStatus: string;
  public creditLimit: number;
  public balance: number;
}
